import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormBrandsRevenueShare: FC = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-l">
        <FormattedMessage id="marketplacePartnerRegisterPage.brands.revenueShare.input.description" />
      </div>
      <MarketplacePartnerRegisterPageFormInputField
        fieldName="revenueShare"
        label={
          <FormattedMessage id="marketplacePartnerRegisterPage.brands.revenueShare.input.label" />
        }
        required
        type="number"
      />
    </div>
  )
}
